import React, { Fragment } from 'react';
import * as Icon from 'react-feather';
import s from './style.module.css';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { queryParams } from '../../utils';



class Frame extends React.Component {
	render(props) {
		const q = queryParams();

		return (
			<Fragment>
				<div className={`${this.props.className} container`}>
					{this.props.children}
				</div>
			</Fragment>
		)
	}
}

export default Frame;
